import i18n from '@assets/i18n/config';

const ACCOUNT_TYPE_CHIP_KEYS = new Set(['PERSONAL', 'CORPORATE']);

const humanizeAccountTypeKey = (accountType: string): string =>
  accountType
    .split('_')
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');

export const formatAuditAccountType = (accountType?: string | null): string => {
  if (!accountType) {
    return '—';
  }

  if (ACCOUNT_TYPE_CHIP_KEYS.has(accountType)) {
    return i18n.t(`bulkRebalance:accountTypeChip.${accountType}`);
  }

  const sharedLabel = i18n.t(`accountTypes:${accountType}`, {
    defaultValue: '',
  });
  if (sharedLabel) {
    return sharedLabel;
  }

  return accountType.includes('_')
    ? humanizeAccountTypeKey(accountType)
    : accountType;
};
